import moment, { Moment } from 'moment';
import 'moment-recur-ts';
import { FirebaseCourseWithUidAndImg } from '../types/types';

export const getCourseOfTheDate = (
  date: Moment,
  courses: FirebaseCourseWithUidAndImg[] | null,
  categoryId: string | undefined,
  ignorePast?: boolean
) =>
  courses &&
  courses
    .filter((course) => {
      if (categoryId ? course.courseCategoryId === categoryId : true) {
        if (course.recurrence.isRecurring) {
          const startDate = moment(course.start).dateOnly();
          const recur =
            // eslint-disable-next-line import/namespace
            startDate
              .recur()
              .every(
                course.recurrence.daysOfWeek
                  .filter(Boolean)
                  .map((day) =>
                    day === '6' ? '0' : (+day + 1).toString()
                  ) as string[],
                'daysOfWeek'
              );
          return recur.matches(date);
        }
        return moment(course.start).isSame(date, 'date');
      }
      return false;
    })
    .sort(
      (a, b) =>
        +moment(a.start).format('HHmm') - +moment(b.start).format('HHmm')
    )
    .map((course) => ({
      ...course,
      startMoment: moment(date)
        .set('hour', moment(course.start).hours())
        .set('minutes', moment(course.start).minutes())
        .set('seconds', 0)
        .set('milliseconds', 0)
        .toJSON(),
      endMoment: moment(date)
        .set('hour', moment(course.start).hours())
        .set('minutes', moment(course.start).minutes())
        .set('seconds', 0)
        .set('milliseconds', 0)
        .add(course.duration, 'minutes')
        .toJSON(),
    }))
    .filter((course) =>
      !ignorePast ? moment(course.endMoment).isSameOrAfter(moment()) : true
    )
    .map((course) => ({
      ...course,
      isNow: moment().isBetween(course.startMoment, course.endMoment),
    }));
